'use strict';

exports.__esModule = true;
// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

var OPEN_SOMETHING_WENT_WRONG_MODAL = exports.OPEN_SOMETHING_WENT_WRONG_MODAL = 'SOMETHING_WENT_WRONG_MODAL_ACTIONS:OPEN_SOMETHING_WENT_WRONG_MODAL';
var CLOSE_SOMETHING_WENT_WRONG_MODAL = exports.CLOSE_SOMETHING_WENT_WRONG_MODAL = 'SOMETHING_WENT_WRONG_MODAL_ACTIONS:CLOSE_SOMETHING_WENT_WRONG_MODAL';

var SomethingWentWrongModalActions = {
	openSomethingWentWrongModal: function openSomethingWentWrongModal() {
		return {
			type: OPEN_SOMETHING_WENT_WRONG_MODAL
		};
	},
	closeSomethingWentWrongModal: function closeSomethingWentWrongModal() {
		return {
			type: CLOSE_SOMETHING_WENT_WRONG_MODAL
		};
	}
};

exports.default = SomethingWentWrongModalActions;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/actions/something-went-wrong-modal.js